import React, { useState } from "react";

const initialFormData = {
  name: "",
  birthdate: "",
  phoneNumber: "",
  gender: "",
  state: "",
  city: "",
  email: "",
  password: "",
  photo: null,
};

const Userreg = () => {
  const [formData, setFormData] = useState(initialFormData);
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handlePhotoChange = (e) => {
    setFormData((prevData) => ({
      ...prevData,
      photo: e.target.files[0],
    }));
  };

  const handleRegisterClick = async () => {
    // Validate required fields
    if (!formData.name || !formData.birthdate || !formData.phoneNumber || 
        !formData.gender || !formData.state || !formData.city || 
        !formData.email || !formData.password) {
      alert("Please fill in all required fields.");
      return;
    }

    setIsLoading(true);

    try {
      const formattedBirthDate = new Date(formData.birthdate).toISOString().split("T")[0];

      const data = {
        name: formData.name,
        birthDate: formattedBirthDate,
        phoneNumber: formData.phoneNumber,
        state: formData.state,
        city: formData.city,
        email: formData.email,
        gender: formData.gender,
        password: formData.password,
        PhotoUrl: "",
      };

      console.log("Submitting Data:", data);

      const response = await fetch("https://api.asterickx.com/api/User", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => null);
        throw new Error(errorData?.message || `Server error: ${response.status}`);
      }

      const result = await response.json();
      console.log("Registration successful:", result);
      
      alert("Registration successful! Redirecting to login page...");
      setFormData(initialFormData);
      
      // Redirect to login page after successful registration
      setTimeout(() => {
        window.location.href = '/login'; // Change this to your actual login page route
      }, 1500);

    } catch (error) {
      console.error("Error submitting form data:", error);
      alert(`Registration failed: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  const inputStyle = {
    border: '1px solid #ced4da',
    borderRadius: '5px',
    padding: '10px',
    width: '100%',
    boxSizing: 'border-box',
    fontSize: '14px',
    transition: 'border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out'
  };

  const inputFocusStyle = {
    borderColor: '#911313',
    boxShadow: '0 0 0 0.25rem rgba(145, 19, 19, 0.25)',
    outline: 'none'
  };

  const labelStyle = {
    fontWeight: 'bold',
    color: '#000000',
    marginBottom: '5px',
    display: 'block',
    fontSize: '14px'
  };

  const buttonStyle = {
    backgroundColor: isLoading ? '#6c757d' : '#3069B5',
    borderColor: isLoading ? '#6c757d' : '#3069B5',
    padding: '12px 30px',
    borderRadius: '5px',
    fontSize: '16px',
    color: '#ffffff',
    cursor: isLoading ? 'not-allowed' : 'pointer',
    border: `1px solid ${isLoading ? '#6c757d' : '#3069B5'}`,
    transition: 'all 0.3s ease',
    opacity: isLoading ? 0.7 : 1
  };

  const buttonHoverStyle = {
    backgroundColor: '#a6d2ff',
    borderColor: '#a6d2ff',
    color : '#333'
  };

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: '10px',
      boxSizing: 'border-box',
      marginBottom: '25px',
      padding: '20px'
    }}>
      <header style={{ textAlign: 'center', marginBottom: '30px' }}>
        <h1 style={{
          color: '#000000',
          marginBottom: '20px',
          fontSize: '2.5rem',
          textAlign: 'center',
          wordWrap: 'break-word'
        }}>
          User Registration
        </h1>
      </header>

      <div style={{
        backgroundColor: '#ffffff',
        border: '1px solid #ced4da',
        borderRadius: '10px',
        padding: '30px',
        width: '100%',
        maxWidth: '800px',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        boxSizing: 'border-box'
      }}>
        
        {/* Grid Container */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '20px',
          marginBottom: '20px'
        }}>
          
          {/* Name */}
          <div>
            <label htmlFor="name" style={labelStyle}>Name</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              disabled={isLoading}
              style={inputStyle}
              onFocus={(e) => {
                Object.assign(e.target.style, inputFocusStyle);
              }}
              onBlur={(e) => {
                e.target.style.borderColor = '#ced4da';
                e.target.style.boxShadow = 'none';
              }}
            />
          </div>

          {/* Birthdate */}
          <div>
            <label htmlFor="birthdate" style={labelStyle}>Birthdate</label>
            <input
              type="date"
              id="birthdate"
              name="birthdate"
              value={formData.birthdate}
              onChange={handleChange}
              required
              disabled={isLoading}
              style={inputStyle}
              onFocus={(e) => {
                Object.assign(e.target.style, inputFocusStyle);
              }}
              onBlur={(e) => {
                e.target.style.borderColor = '#ced4da';
                e.target.style.boxShadow = 'none';
              }}
            />
          </div>

          {/* Phone Number */}
          <div>
            <label htmlFor="phoneNumber" style={labelStyle}>Phone Number</label>
            <input
              type="tel"
              id="phoneNumber"
              name="phoneNumber"
              value={formData.phoneNumber}
              onChange={handleChange}
              required
              disabled={isLoading}
              style={inputStyle}
              onFocus={(e) => {
                Object.assign(e.target.style, inputFocusStyle);
              }}
              onBlur={(e) => {
                e.target.style.borderColor = '#ced4da';
                e.target.style.boxShadow = 'none';
              }}
            />
          </div>

          {/* Gender */}
          <div>
            <label htmlFor="gender" style={labelStyle}>Gender</label>
            <select
              id="gender"
              name="gender"
              value={formData.gender}
              onChange={handleChange}
              required
              disabled={isLoading}
              style={inputStyle}
              onFocus={(e) => {
                Object.assign(e.target.style, inputFocusStyle);
              }}
              onBlur={(e) => {
                e.target.style.borderColor = '#ced4da';
                e.target.style.boxShadow = 'none';
              }}
            >
              <option value="">Select Gender</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
              <option value="Other">Other</option>
            </select>
          </div>

          {/* City */}
          <div>
            <label htmlFor="city" style={labelStyle}>City</label>
            <input
              type="text"
              id="city"
              name="city"
              value={formData.city}
              onChange={handleChange}
              required
              disabled={isLoading}
              style={inputStyle}
              onFocus={(e) => {
                Object.assign(e.target.style, inputFocusStyle);
              }}
              onBlur={(e) => {
                e.target.style.borderColor = '#ced4da';
                e.target.style.boxShadow = 'none';
              }}
            />
          </div>

          {/* State */}
          <div>
            <label htmlFor="state" style={labelStyle}>State</label>
            <input
              type="text"
              id="state"
              name="state"
              value={formData.state}
              onChange={handleChange}
              required
              disabled={isLoading}
              style={inputStyle}
              onFocus={(e) => {
                Object.assign(e.target.style, inputFocusStyle);
              }}
              onBlur={(e) => {
                e.target.style.borderColor = '#ced4da';
                e.target.style.boxShadow = 'none';
              }}
            />
          </div>

          {/* Email */}
          <div>
            <label htmlFor="email" style={labelStyle}>Email</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              disabled={isLoading}
              style={inputStyle}
              onFocus={(e) => {
                Object.assign(e.target.style, inputFocusStyle);
              }}
              onBlur={(e) => {
                e.target.style.borderColor = '#ced4da';
                e.target.style.boxShadow = 'none';
              }}
            />
          </div>

          {/* Password */}
          <div>
            <label htmlFor="password" style={labelStyle}>Password</label>
            <div style={{ position: 'relative' }}>
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                required
                disabled={isLoading}
                style={{
                  ...inputStyle,
                  paddingRight: '40px'
                }}
                onFocus={(e) => {
                  Object.assign(e.target.style, inputFocusStyle);
                  e.target.style.paddingRight = '40px';
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = '#ced4da';
                  e.target.style.boxShadow = 'none';
                }}
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  position: 'absolute',
                  right: '10px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  color: '#6c757d',
                  fontSize: '18px',
                  padding: '0',
                  width: '24px',
                  height: '24px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
                disabled={isLoading}
                title={showPassword ? "Hide password" : "Show password"}
              >
                {showPassword ? '👁️' : '👁️‍🗨️'}
              </button>
            </div>
          </div>

          {/* Photo - spans full width on larger screens */}
          <div style={{ 
            gridColumn: window.innerWidth > 600 ? '1 / -1' : 'auto'
          }}>
            <label htmlFor="photo" style={labelStyle}>Photo (optional)</label>
            <input
              type="file"
              id="photo"
              name="photo"
              onChange={handlePhotoChange}
              disabled={isLoading}
              style={{
                ...inputStyle,
                padding: '6px 12px'
              }}
              onFocus={(e) => {
                Object.assign(e.target.style, inputFocusStyle);
              }}
              onBlur={(e) => {
                e.target.style.borderColor = '#ced4da';
                e.target.style.boxShadow = 'none';
              }}
            />
          </div>
        </div>

        {/* Submit Button */}
        <div style={{ textAlign: 'center', marginTop: '30px' }}>
          <button
            type="button"
            onClick={handleRegisterClick}
            disabled={isLoading}
            style={buttonStyle}
            onMouseEnter={(e) => {
              if (!isLoading) {
                Object.assign(e.target.style, buttonHoverStyle);
              }
            }}
            onMouseLeave={(e) => {
              Object.assign(e.target.style, buttonStyle);
            }}
          >
            {isLoading ? "Registering..." : "Register"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Userreg;